module.exports = __webpack_public_path__ + "content/4d363172c766c7ac5c09e1ebe75a1516.svg";